export type Portrait = string;

export type PortraitPair = {
  left?: Portrait;
  right?: Portrait;
};

export type PortraitGroups = {
  left: Portrait[];
  right: Portrait[];
};

export type PortraitIndices = {
  left: number;
  right: number;
};

export const INITIAL_PORTRAIT_INDICES: PortraitIndices = { left: 0, right: 0 };

function portraitAt(group: Portrait[], index: number): Portrait | undefined {
  if (!group.length) {
    return undefined;
  }

  return group[index % group.length];
}

export function getInitialPortraitPair(groups: PortraitGroups): PortraitPair | null {
  const left = groups.left[0];
  const right = groups.right[0];

  if (!left && !right) {
    return null;
  }

  return { left, right };
}

export function getNextPortraitIndices(groups: PortraitGroups, current: PortraitIndices): PortraitIndices {
  return {
    left: groups.left.length ? (current.left + 1) % groups.left.length : 0,
    right: groups.right.length ? (current.right + 1) % groups.right.length : 0,
  };
}

export function getPortraitPairAt(groups: PortraitGroups, indices: PortraitIndices): PortraitPair | null {
  const left = portraitAt(groups.left, indices.left);
  const right = portraitAt(groups.right, indices.right);

  if (!left && !right) {
    return null;
  }

  return { left, right };
}

export function hasNextPortraitStep(groups: PortraitGroups): boolean {
  return groups.left.length > 1 || groups.right.length > 1;
}
